export function getBooleanLabel(value: boolean){
    return (value)?'yes':'no';
}

export function getLabelSize (size:number) {
    const gigabyte = size / 1024 / 1024 / 1024;

    if (gigabyte > 1){
        return gigabyte.toFixed(2) + ' GB';
    }

    const megabyte = size / 1024 / 1024;
    return megabyte.toFixed(1) + ' MB';
};
